import React from 'react'

const SvgPictureInPictureOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 5h14v3h2V5a2 2 0 00-2-2H4a2 2 0 00-2 2v11a2 2 0 002 2h4v-2H4V5z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 19a2 2 0 002 2h8a2 2 0 002-2v-7a2 2 0 00-2-2h-8a2 2 0 00-2 2v7zm10 0v-7h-8v7h8zM4 5v11h4v2H4a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v3h-2V5H4z'
    />
  </svg>
)

export default SvgPictureInPictureOutline
